module.exports = __webpack_public_path__ + "img/soccerboard28.03485ed4.jpg";